import { render, staticRenderFns } from "./seleagentdailog.vue?vue&type=template&id=b56fc996"
import script from "./seleagentdailog.vue?vue&type=script&lang=js"
export * from "./seleagentdailog.vue?vue&type=script&lang=js"
import style0 from "./seleagentdailog.vue?vue&type=style&index=0&id=b56fc996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports